<div
  class="progress-bar-container"
  [ngClass]="{
    'complete-bar': progress_percent === 100
  }"
>
  <div class="progress-bar">
    <div class="progress-fill" [style.width.%]="progress_percent"></div>
  </div>

  <span class="percent-text">{{ progress_percent | number : '1.0-0' }} %</span>
</div>
